import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateRefetchApiCall } from '../../store/reducers/apiCallSlice';
import { NavigationConfig } from '../../utils/navigation-constants';
import GpuMetrics from './gpu-metrics';
import HeaterMetrics from './heater-metrics';
import UserDetails from './user-details';

interface TabPanelProps {
    children: React.ReactNode;
    index: number;
    value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            height="calc(100dvh - 200px)"
            overflow="auto"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Box>
    );
};

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const CustomerDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const customerData = location.state?.customerData;

    console.warn(customerData, 'customerData');
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const onEditEvent = () => {
        dispatch(
            updateRefetchApiCall({
                page: 1,
            }),
        );
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" width="100%" alignItems="center">
                <Box display="flex" alignItems="center">
                    <IconButton
                        onClick={() => {
                            navigate(NavigationConfig.ManageCustomer);
                        }}
                    >
                        <KeyboardBackspaceIcon />
                    </IconButton>{' '}
                    <Typography variant="h4" pl={1}>
                        {customerData?.username}
                    </Typography>
                </Box>
            </Stack>
            <Box sx={{ width: '100%' }} p={0} pt={2.5}>
                <Box>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label={t('customer_details')} {...a11yProps(0)} />
                        <Tab label={t('heater_metrics')} {...a11yProps(1)} />
                        <Tab label={t('gpu_metrics')} {...a11yProps(2)} />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <UserDetails userData={customerData} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <HeaterMetrics userData={customerData} onEditEvent={onEditEvent} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <GpuMetrics userData={customerData} onEditEvent={onEditEvent} />
                </CustomTabPanel>
            </Box>
        </>
    );
};
export default CustomerDetails;
